import { Stack } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Navigator } from '../../../components/Navigator';
import { PageLayout } from '../../../layout';
import { AdminInvoiceInfoBox } from './modules/AdminInvoiceInfoBox';
import { AdminInvoicePageHeader } from './modules/AdminInvoicePageHeader';
import { InvoiceContactsInfoBox } from './modules/InvoiceContactsInfoBox';
import { InvoiceRemindingToneBox } from './modules/InvoiceRemindingToneBox';
import { InvoiceScheduledActionsBox } from './modules/InvoiceScheduledActionsBox';
import { InvoiceStatusInfoBoxModule } from './modules/InvoiceStatusInfoBox';

const TRANS_NS = 'page-admin-task-detail';
export const AdminInvoiceDetail = () => {
  const { t } = useTranslation(TRANS_NS);
  const { invoiceId } = useParams();

  const navLinks = [
    {
      href: '#customer',
      label: t('customer'),
    },
    {
      href: '#invoice',
      label: t('invoiceInfo'),
    },
    {
      href: '#scheduledActions',
      label: t('scheduledActions.all'),
    },
  ];

  return (
    <PageLayout>
      {invoiceId ? <AdminInvoicePageHeader invoiceId={invoiceId} /> : null}

      <Grid2 mt={4} container spacing={2}>
        <Grid2 xs={12} md={10}>
          <Stack spacing={4}>
            {invoiceId ? <InvoiceContactsInfoBox invoiceId={invoiceId} id={'customer'} /> : null}
            {invoiceId ? <AdminInvoiceInfoBox invoiceId={invoiceId} id={'invoice'} /> : null}
            {invoiceId ? <InvoiceScheduledActionsBox invoiceId={invoiceId} id={'scheduledActions'} /> : null}
          </Stack>
        </Grid2>
        <Grid2 xs={12} md={2}>
          <Stack gap={4} sx={{ position: 'sticky', top: 20, minWidth: 200 }}>
            {invoiceId ? <InvoiceStatusInfoBoxModule invoiceId={invoiceId} id={'invoiceStatus'} /> : null}
            {invoiceId ? <InvoiceRemindingToneBox invoiceId={invoiceId} id={'remindingTone'} /> : null}
            <Navigator navLinks={navLinks} />
          </Stack>
        </Grid2>
      </Grid2>
    </PageLayout>
  );
};
